import React from 'react';
import {ArrowRight, Mail, Eye, LineChart, Upload} from 'lucide-react';
import {Link} from "react-router-dom";

const ClientDocumentPageActions = ({ user, clientId, includeProgressBtn = false, year = '2024' }) => {
    console.log(clientId);
    return (
        <div className="flex justify-end items-center">
            <div className="grid gap-2 md:justify-end basis-auto grid-cols-2">

                <Link
                    to={`/client/${clientId}/upload${year ? `?year=${year}`:''}`}
                    className="inline-flex items-center justify-center gap-2 px-4 py-2
                    min-w-[140px] md:min-w-0
                    text-xs

                    bg-indigo-500 dark:bg-indigo-600
                    text-white
                    hover:bg-indigo-600 dark:hover:bg-indigo-700
                    rounded-md transition-colors"
                >
                    Upload Document for {user.profile.client}
                    <Upload className="w-4 h-4"/>
                </Link>
                {includeProgressBtn && (
                    <Link
                        to={`/client-progress/${user.id}${year ? `?year=${year}`:''}`}
                        className="flex-grow text-xs inline-flex items-center justify-center gap-2 px-4 py-2 text-white rounded-lg transition-colors text-center bg-indigo-500 dark:bg-indigo-600
                    text-white
                    hover:bg-indigo-600 dark:hover:bg-indigo-700"
                    >
                        Progress <LineChart className="w-4 h-4"/>
                    </Link>
                )}
                <Link
                    to={`/view-letters/${clientId}${year ? `?year=${year}`:''}`}
                    className="inline-flex items-center justify-center gap-2 px-4 py-2
                    min-w-[140px] md:min-w-0
                    text-xs
                    bg-blue-500 dark:bg-blue-600
                    text-white
                    hover:bg-blue-600 dark:hover:bg-blue-700
                    rounded-md transition-colors"
                >
                    View Sent Letters
                    <Mail className="w-4 h-4"/>
                </Link>
                <Link
                    to={`/send-letter/${clientId}`}
                    className="inline-flex items-center justify-center gap-2 px-4 py-2
                    min-w-[140px] md:min-w-0
                    text-xs

                    border border-red-500 dark:border-red-400
                    text-red-500 dark:text-red-400
                    hover:bg-red-50 dark:hover:bg-red-900/20
                    rounded-md transition-colors"
                >
                    Send Letter
                    <ArrowRight className="w-4 h-4"/>
                </Link>



            </div>
        </div>
    );
};

export default ClientDocumentPageActions;
